import React, { useState } from 'react';
import { ChevronDown, ChevronUp, ArrowRight, Filter, Download, ArrowUpRight } from 'lucide-react';

export default function MediaPlanTable() {
  const [expandedFormat, setExpandedFormat] = useState(null);
  const [expandedPlatform, setExpandedPlatform] = useState(null);
  const [viewMode, setViewMode] = useState('budget'); // 'budget', 'performance', 'audience'
  
  const toggleFormat = (platformId, formatId) => {
    const key = `${platformId}-${formatId}`;
    if (expandedFormat === key) {
      setExpandedFormat(null);
    } else {
      setExpandedFormat(key);
    }
  };
  
  const togglePlatform = (platformId) => {
    if (expandedPlatform === platformId) {
      setExpandedPlatform(null);
    } else {
      setExpandedPlatform(platformId);
    }
  };
  
  // Platform ve format verileri
  const platformData = [
    {
      id: 'meta',
      name: 'Meta Ads',
      color: 'bg-blue-500',
      textColor: 'text-blue-600',
      bgColor: 'bg-blue-50',
      borderColor: 'border-blue-200',
      totalBudget: 122000,
      totalReach: 12500000,
      totalImpressions: 17800000,
      totalVideoViews: 240000,
      totalClicks: 0,
      formats: [
        {
          id: 'engagement',
          name: 'Engagement',
          objective: 'Brand Awareness',
          budget: 32000,
          reach: 1000000,
          impressions: 1046436,
          frequency: 1.05,
          cpm: 30.58,
          audiences: [
            { name: 'Interest', details: 'Tech, Mobile, Gadgets' },
            { name: 'Lookalike', details: 'Based on website visitors' }
          ]
        },
        {
          id: 'reach',
          name: 'Reach',
          objective: 'Brand Awareness',
          budget: 5000,
          reach: 738552,
          impressions: 738552,
          frequency: 1.0,
          cpm: 6.77,
          audiences: [
            { name: 'Interest', details: 'Tech, Mobile, Gadgets' }
          ]
        },
        {
          id: 'video_views',
          name: 'Video Views',
          objective: 'Brand Awareness',
          budget: 60000,
          reach: 6000000,
          impressions: 6000000,
          frequency: 1.0,
          cpm: 10.00,
          cpv: 0.25,
          videoViews: 240000,
          audiences: [
            { name: 'Interest', details: 'Tech, Mobile, Gadgets' },
            { name: 'Lookalike', details: 'Based on past video viewers' }
          ]
        },
        {
          id: 'store_visit',
          name: 'Store Visit',
          objective: 'Consideration',
          budget: 25000,
          reach: 4765000,
          impressions: 4078303,
          frequency: 1.17,
          cpm: 6.13,
          audiences: [
            { name: 'Lookalike', details: 'Based on store visitors' }
          ]
        }
      ]
    },
    {
      id: 'google',
      name: 'Google Ads',
      color: 'bg-green-500',
      textColor: 'text-green-600',
      bgColor: 'bg-green-50',
      borderColor: 'border-green-200',
      totalBudget: 220000,
      totalReach: 10281690,
      totalImpressions: 10281690,
      totalVideoViews: 2000000,
      totalClicks: 6933,
      formats: [
        {
          id: 'display',
          name: 'Display',
          objective: 'Brand Awareness',
          budget: 20000,
          reach: 281690,
          impressions: 281690,
          frequency: 1.0,
          cpm: 71.00,
          cpc: 6.82,
          clicks: 2933,
          audiences: [
            { name: 'Custom Affinity', details: 'Tech enthusiasts' },
            { name: 'Custom Intent', details: 'Phone upgrade searches' }
          ]
        },
        {
          id: 'youtube_video',
          name: 'YouTube Video',
          objective: 'Brand Awareness',
          budget: 200000,
          reach: 10000000,
          impressions: 10000000,
          frequency: 1.0,
          cpm: 20.00,
          cpv: 0.10,
          videoViews: 2000000,
          cpc: 50.00,
          clicks: 4000,
          audiences: [
            { name: 'Custom Affinity', details: 'Tech enthusiasts' },
            { name: 'Custom Intent', details: 'Phone reviews searches' }
          ]
        }
      ]
    },
    {
      id: 'tiktok',
      name: 'TikTok',
      color: 'bg-pink-500',
      textColor: 'text-pink-600',
      bgColor: 'bg-pink-50',
      borderColor: 'border-pink-200',
      totalBudget: 70000,
      totalReach: 9915014,
      totalImpressions: 9915014,
      totalVideoViews: 0,
      totalClicks: 0,
      formats: [
        {
          id: 'tiktok',
          name: 'TikTok Ads',
          objective: 'Brand Awareness',
          budget: 70000,
          reach: 9915014,
          impressions: 9915014,
          frequency: 1.0,
          cpm: 7.06,
          audiences: [
            { name: 'Interest', details: 'Tech, Gadgets' }
          ]
        }
      ]
    },
    {
      id: 'dv360',
      name: 'DV360',
      color: 'bg-purple-500',
      textColor: 'text-purple-600',
      bgColor: 'bg-purple-50',
      borderColor: 'border-purple-200',
      totalBudget: 100000,
      totalReach: 8333333,
      totalImpressions: 8333333,
      totalVideoViews: 100000,
      totalClicks: 0,
      formats: [
        {
          id: 'reach_video',
          name: 'Reach - Video',
          objective: 'Brand Awareness',
          budget: 50000,
          reach: 3333333,
          impressions: 3333333,
          frequency: 1.0,
          cpm: 15.00,
          cpv: 0.50,
          videoViews: 100000,
          audiences: [
            { name: 'Custom Affinity', details: 'Tech enthusiasts' },
            { name: 'Custom Intent', details: 'Phone upgrade searches' },
            { name: 'URL Placement', details: 'Tech blogs and forums' }
          ]
        },
        {
          id: 'reach_banner',
          name: 'Reach - Banner',
          objective: 'Brand Awareness',
          budget: 50000,
          reach: 5000000,
          impressions: 5000000,
          frequency: 1.0,
          cpm: 10.00,
          audiences: [
            { name: 'Custom Affinity', details: 'Tech enthusiasts' },
            { name: 'Interest', details: 'Tech, Mobile' },
            { name: 'Category', details: 'Technology' }
          ]
        }
      ]
    },
    {
      id: 'pinterest',
      name: 'Pinterest',
      color: 'bg-red-500',
      textColor: 'text-red-600',
      bgColor: 'bg-red-50',
      borderColor: 'border-red-200',
      totalBudget: 10000,
      totalReach: 871080,
      totalImpressions: 871080,
      totalVideoViews: 0,
      totalClicks: 1058,
      formats: [
        {
          id: 'pinterest',
          name: 'Pinterest',
          objective: 'Brand Awareness',
          budget: 10000,
          reach: 871080,
          impressions: 871080,
          frequency: 1.0,
          cpm: 11.48,
          cpc: 9.45,
          clicks: 1058,
          audiences: [
            { name: 'Interest', details: 'Tech, Gadgets, Mobile' }
          ]
        }
      ]
    }
  ];
  
  // Toplam kampanya metrikleri
  const campaignTotals = {
    budget: platformData.reduce((sum, p) => sum + p.totalBudget, 0),
    reach: platformData.reduce((sum, p) => sum + p.totalReach, 0),
    impressions: platformData.reduce((sum, p) => sum + p.totalImpressions, 0),
    videoViews: platformData.reduce((sum, p) => sum + p.totalVideoViews, 0),
    clicks: platformData.reduce((sum, p) => sum + p.totalClicks, 0),
  };
  
  // KPI görünümüne göre kolon başlıkları
  const columnHeaders = {
    'budget': [
      { id: 'platform', label: 'Platform / Format' },
      { id: 'objective', label: 'Objective' },
      { id: 'budget', label: 'Budget (₺)', align: 'right' },
      { id: 'budget_share', label: 'Share (%)', align: 'right' },
    ],
    'performance': [
      { id: 'platform', label: 'Platform / Format' },
      { id: 'reach', label: 'Reach', align: 'right' },
      { id: 'cpm', label: 'CPM (₺)', align: 'right' },
      { id: 'frequency', label: 'Frequency', align: 'right' },
      { id: 'videoViews', label: 'Video Views', align: 'right' },
    ],
    'audience': [
      { id: 'platform', label: 'Platform / Format' },
      { id: 'objective', label: 'Objective' },
      { id: 'audiences', label: 'Audience Targeting', align: 'left' },
    ]
  };
  
  // Aktif kolon başlıkları
  const activeColumns = columnHeaders[viewMode];

  // Formatlı hücre değerlerini döndüren fonksiyon
  const getCellValue = (row, column) => {
    switch(column.id) {
      case 'platform':
        return row.name;
      case 'objective':
        return row.objective || '';
      case 'budget':
        return `₺${row.budget?.toLocaleString() || 0}`;
      case 'budget_share':
        return ((row.budget / campaignTotals.budget) * 100).toFixed(1) + '%';
      case 'reach':
        return (row.reach / 1000000).toFixed(1) + 'M';
      case 'cpm':
        return `₺${row.cpm?.toFixed(2) || 0}`;
      case 'frequency':
        return row.frequency?.toFixed(1) || '1.0';
      case 'videoViews':
        return row.videoViews ? (row.videoViews / 1000).toFixed(0) + 'K' : '-';
      case 'audiences':
        return row.audiences ? row.audiences.map(a => a.name).join(', ') : '';
      default:
        return '';
    }
  };

  return (
    <div className="p-6">
      <div className="flex justify-between items-center mb-4">
        <h1 className="text-xl font-bold">Media Plan</h1>
        
        <div className="flex items-center gap-2">
          <div className="flex bg-gray-100 rounded-lg p-1">
            <button 
              className={`px-3 py-1 text-sm rounded-md ${viewMode === 'budget' ? 'bg-white shadow-sm' : 'text-gray-500'}`}
              onClick={() => setViewMode('budget')}
            >
              Budget
            </button>
            <button 
              className={`px-3 py-1 text-sm rounded-md ${viewMode === 'performance' ? 'bg-white shadow-sm' : 'text-gray-500'}`}
              onClick={() => setViewMode('performance')}
            >
              Performance
            </button>
            <button 
              className={`px-3 py-1 text-sm rounded-md ${viewMode === 'audience' ? 'bg-white shadow-sm' : 'text-gray-500'}`}
              onClick={() => setViewMode('audience')}
            >
              Audience
            </button>
          </div>
          
          <button className="p-2 text-gray-500 hover:text-gray-700 rounded-md hover:bg-gray-100">
            <Filter className="w-4 h-4" />
          </button>
          
          <button className="p-2 text-gray-500 hover:text-gray-700 rounded-md hover:bg-gray-100">
            <Download className="w-4 h-4" />
          </button>
        </div>
      </div>
      
      {/* KPI Kartları */}
      <div className="grid grid-cols-4 gap-4 mb-6">
        <div className="bg-gradient-to-br from-[#9A80CA] to-[#bba6e6] rounded-xl p-4 border border-[#bba6e6] flex items-center justify-between shadow-md">
          <div>
            <div className="text-xs text-[#9A80CA] font-medium uppercase tracking-wide">Total Budget</div>
            <div className="mt-1 text-2xl font-bold text-[#7C5DB0]">₺{campaignTotals.budget.toLocaleString()}</div>
          </div>
          <div className="text-[#bba6e6] flex items-center gap-1 text-xs">
            <ArrowUpRight className="w-3 h-3" />
            <span>100%</span>
          </div>
        </div>
        
        <div className="bg-gradient-to-br from-[#bba6e6] to-[#E3E8FF] rounded-xl p-4 border border-[#bba6e6] flex items-center justify-between shadow-md">
          <div>
            <div className="text-xs text-[#9A80CA] font-medium uppercase tracking-wide">Total Reach</div>
            <div className="mt-1 text-2xl font-bold text-[#7C5DB0]">{(campaignTotals.reach / 1000000).toFixed(1)}M</div>
          </div>
          <div className="text-[#9A80CA] flex items-center gap-1 text-xs">
            <ArrowUpRight className="w-3 h-3" />
            <span>Unique</span>
          </div>
        </div>
        
        <div className="bg-gradient-to-br from-[#E3E8FF] to-[#bba6e6] rounded-xl p-4 border border-[#bba6e6] flex items-center justify-between shadow-md">
          <div>
            <div className="text-xs text-[#9A80CA] font-medium uppercase tracking-wide">Total Impressions</div>
            <div className="mt-1 text-2xl font-bold text-[#7C5DB0]">{(campaignTotals.impressions / 1000000).toFixed(1)}M</div>
          </div>
          <div className="text-[#9A80CA] flex items-center gap-1 text-xs">
            <ArrowUpRight className="w-3 h-3" />
            <span>Avg Freq: 1.2</span>
          </div>
        </div>
        
        <div className="bg-gradient-to-br from-[#9A80CA] to-[#4F8CFF] rounded-xl p-4 border border-[#bba6e6] flex items-center justify-between shadow-md">
          <div>
            <div className="text-xs text-[#9A80CA] font-medium uppercase tracking-wide">Total Video Views</div>
            <div className="mt-1 text-2xl font-bold text-[#7C5DB0]">{(campaignTotals.videoViews / 1000000).toFixed(1)}M</div>
          </div>
          <div className="text-[#4F8CFF] flex items-center gap-1 text-xs">
            <ArrowUpRight className="w-3 h-3" />
            <span>3s+</span>
          </div>
        </div>
      </div>
      
      {/* Bütçe Çubukları */}
      <div className="mb-4">
        <div className="h-2 w-full bg-gray-100 rounded-full overflow-hidden flex">
          {platformData.map((platform, index) => (
            <div 
              key={index}
              className={`h-full ${platform.color}`}
              style={{ width: `${(platform.totalBudget / campaignTotals.budget) * 100}%` }}
            ></div>
          ))}
        </div>
        <div className="flex justify-between mt-2 text-xs text-gray-500">
          {platformData.map((platform, index) => (
            <div key={index} className="flex items-center">
              <div className={`h-2 w-2 rounded-full ${platform.color} mr-1`}></div>
              <span>{platform.name}</span>
              <span className="ml-1 font-medium">({((platform.totalBudget / campaignTotals.budget) * 100).toFixed(0)}%)</span>
            </div>
          ))}
        </div>
      </div>
      
      {/* Ana Tablo */}
      <div className="bg-white rounded-xl shadow-sm border overflow-hidden">
        {/* Tablo Başlıkları */}
        <div className="bg-gradient-to-r from-[#9A80CA] to-[#bba6e6] px-4 py-3 border-b">
          <div className="grid grid-cols-12 gap-2">
            {activeColumns.map((column, index) => (
              <div 
                key={index} 
                className={`
                  text-xs font-bold text-white uppercase tracking-wider
                  ${column.id === 'platform' ? 'col-span-4' : column.id === 'audiences' ? 'col-span-5' : 'col-span-2'}
                  ${column.align === 'right' ? 'text-right' : 'text-left'}
                `}
              >
                {column.label}
              </div>
            ))}
          </div>
        </div>
        
        {/* Tablo Gövdesi */}
        <div className="divide-y divide-gray-100">
          {platformData.map((platform) => (
            <div key={platform.id}>
              {/* Platform Satırı */}
              <div 
                className={`
                  px-4 py-3 grid grid-cols-12 gap-2 cursor-pointer hover:bg-gray-50
                  ${expandedPlatform === platform.id ? `bg-${platform.bgColor}` : ''}
                `}
                onClick={() => togglePlatform(platform.id)}
              >
                <div className="col-span-4 flex items-center gap-2 font-medium">
                  <div className={`h-3 w-3 rounded-full ${platform.color}`}></div>
                  <span>{platform.name}</span>
                  {platform.formats.length > 1 && (
                    <div className="ml-1">
                      {expandedPlatform === platform.id ? 
                        <ChevronUp className="w-4 h-4 text-gray-400" /> : 
                        <ChevronDown className="w-4 h-4 text-gray-400" />
                      }
                    </div>
                  )}
                </div>
                
                {/* Değişken sütunlar */}
                {viewMode === 'budget' && (
                  <>
                    <div className="col-span-2 flex items-center">
                      <span className="px-2 py-0.5 bg-blue-50 text-blue-700 rounded-full text-xs font-medium">
                        Brand Awareness
                      </span>
                    </div>
                    <div className="col-span-2 text-right font-medium">
                      ₺{platform.totalBudget.toLocaleString()}
                    </div>
                    <div className="col-span-2 text-right text-gray-500">
                      {((platform.totalBudget / campaignTotals.budget) * 100).toFixed(1)}%
                    </div>
                  </>
                )}
                
                {viewMode === 'performance' && (
                  <>
                    <div className="col-span-2 text-right">
                      {(platform.totalReach / 1000000).toFixed(1)}M
                    </div>
                    <div className="col-span-2 text-right">
                      ₺{(platform.totalBudget / platform.totalImpressions * 1000).toFixed(2)}
                    </div>
                    <div className="col-span-2 text-right">
                      {(platform.totalImpressions / platform.totalReach).toFixed(1)}
                    </div>
                    <div className="col-span-2 text-right">
                      {platform.totalVideoViews > 0 ? (platform.totalVideoViews / 1000).toFixed(0) + 'K' : '-'}
                    </div>
                  </>
                )}
                
                {viewMode === 'audience' && (
                  <>
                    <div className="col-span-2 flex items-center">
                      <span className="px-2 py-0.5 bg-blue-50 text-blue-700 rounded-full text-xs font-medium">
                        Brand Awareness
                      </span>
                    </div>
                    <div className="col-span-5 text-left text-gray-500">
                      {Array.from(new Set(platform.formats.flatMap(f => f.audiences?.map(a => a.name) || []))).join(', ')}
                    </div>
                  </>
                )}
              </div>
              
              {/* Format Satırları - Platform açılmışsa gösterilir */}
              {expandedPlatform === platform.id && (
                <div className="bg-gray-50 divide-y divide-gray-100 border-t border-gray-100">
                  {platform.formats.map((format) => (
                    <div key={format.id}>
                      <div 
                        className={`
                          px-4 py-2 pl-8 grid grid-cols-12 gap-2 cursor-pointer hover:bg-gray-100
                          ${expandedFormat === `${platform.id}-${format.id}` ? `bg-${platform.bgColor} bg-opacity-50` : ''}
                        `}
                        onClick={() => toggleFormat(platform.id, format.id)}
                      >
                        <div className="col-span-4 flex items-center gap-1 text-sm">
                          <div className={`h-1 w-1 rounded-full ${platform.color}`}></div>
                          <span>{format.name}</span>
                          {format.audiences && format.audiences.length > 0 && viewMode === 'audience' && (
                            <div className="ml-1">
                              {expandedFormat === `${platform.id}-${format.id}` ? 
                                <ChevronUp className="w-3 h-3 text-gray-400" /> : 
                                <ChevronDown className="w-3 h-3 text-gray-400" />
                              }
                            </div>
                          )}
                        </div>
                        
                        {/* Değişken sütunlar */}
                        {viewMode === 'budget' && (
                          <>
                            <div className="col-span-2 flex items-center">
                              <span className="px-2 py-0.5 bg-blue-50 text-blue-700 rounded-full text-xs">
                                {format.objective}
                              </span>
                            </div>
                            <div className="col-span-2 text-right">
                              ₺{format.budget.toLocaleString()}
                            </div>
                            <div className="col-span-2 text-right text-gray-500">
                              {((format.budget / campaignTotals.budget) * 100).toFixed(1)}%
                            </div>
                          </>
                        )}
                        
                        {viewMode === 'performance' && (
                          <>
                            <div className="col-span-2 text-right">
                              {(format.reach / 1000000).toFixed(1)}M
                            </div>
                            <div className="col-span-2 text-right">
                              ₺{format.cpm?.toFixed(2) || 0}
                            </div>
                            <div className="col-span-2 text-right">
                              {format.frequency?.toFixed(1) || '1.0'}
                            </div>
                            <div className="col-span-2 text-right">
                              {format.videoViews ? (format.videoViews / 1000).toFixed(0) + 'K' : '-'}
                            </div>
                          </>
                        )}
                        
                        {viewMode === 'audience' && (
                          <>
                            <div className="col-span-2 flex items-center">
                              <span className="px-2 py-0.5 bg-blue-50 text-blue-700 rounded-full text-xs">
                                {format.objective}
                              </span>
                            </div>
                            <div className="col-span-5 text-left text-gray-500">
                              {format.audiences?.map(a => a.name).join(', ') || ''}
                            </div>
                          </>
                        )}
                      </div>
                      
                      {/* Audience Detayları - Format açılmışsa ve audience modundaysak */}
                      {expandedFormat === `${platform.id}-${format.id}` && viewMode === 'audience' && format.audiences && (
                        <div className="px-12 py-2 bg-white border-t border-gray-100">
                          <div className="space-y-2">
                            {format.audiences.map((audience, index) => (
                              <div key={index} className="grid grid-cols-2 text-sm">
                                <div className={`font-medium ${platform.textColor}`}>{audience.name}:</div>
                                <div>{audience.details}</div>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
          
          {/* Toplam Satırı */}
          <div className="px-4 py-3 grid grid-cols-12 gap-2 bg-gradient-to-r from-[#9A80CA] to-[#bba6e6] font-bold border-t text-white">
            <div className="col-span-4">TOTAL</div>
            
            {viewMode === 'budget' && (
              <>
                <div className="col-span-2"></div>
                <div className="col-span-2 text-right">₺{campaignTotals.budget.toLocaleString()}</div>
                <div className="col-span-2 text-right">100%</div>
              </>
            )}
            
            {viewMode === 'performance' && (
              <>
                <div className="col-span-2 text-right">{(campaignTotals.reach / 1000000).toFixed(1)}M</div>
                <div className="col-span-2 text-right">₺{(campaignTotals.budget / campaignTotals.impressions * 1000).toFixed(2)}</div>
                <div className="col-span-2 text-right">{(campaignTotals.impressions / campaignTotals.reach).toFixed(1)}</div>
                <div className="col-span-2 text-right">{(campaignTotals.videoViews / 1000000).toFixed(1)}M</div>
              </>
            )}
            
            {viewMode === 'audience' && (
              <>
                <div className="col-span-2"></div>
                <div className="col-span-5"></div>
              </>
            )}
          </div>
        </div>
      </div>
      
      {/* Dipnot ve Zamanlanmış İyileştirmeler */}
      <div className="mt-4 text-xs text-gray-500 space-y-1">
        <div>* CPM values are campaign estimates based on historical platform data</div>
        <div>* Video views counted when at least 3 seconds are watched (2 seconds for TikTok)</div>
      </div>
    </div>
  );
}

// Arayüzü Eye bileşeni
const Eye = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
    <circle cx="12" cy="12" r="3"></circle>
  </svg>
); 